import $ from "jquery";

const init = () => {
    reloadPage();
};

const reloadPage = () => {
  if (!$("#news-sort").length) return;

  $("#news-sort").on("change", function () {
    let url = window.location.href;    

    if(url.includes('&')) {
        url = url.slice(0, url.lastIndexOf('&'));
    }
    
    if (url.indexOf('?') > -1){
        url += `&news-order=${this.value}`
    }else{
        url += `?news-order=${this.value}`
    }

    window.location.href = url;
  });
};

try {
  init();
} catch (error) {
  console.log(error);
}
